export enum TippingCulture {
  APPRECIATED = 'APPRECIATED',
  CUSTOMARY = 'CUSTOMARY',
  NONE = 'NONE',
}
